// Products State

export default {
  fullRawMaterialsList: [],
  rawMaterialsList: [],
  rawMaterialInfo: {}
}
